import { render, staticRenderFns } from "./Memos.vue?vue&type=template&id=9de1e74c"
import script from "./Memos.vue?vue&type=script&lang=js"
export * from "./Memos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports